import { domain } from 'modules/data';
import { useCreateNetSuiteExpenseLineMatching, useCreateNetSuiteItemLineMatching } from 'shared/data/webApp/v2';

export const useCreateMatching = (lineType: domain.NetSuiteMatchingLineType | undefined) => {
    const { mutate: createNetSuiteItemLineMatching, isLoading: isLoadingCreateNetSuiteItemLineMatching } =
        useCreateNetSuiteItemLineMatching();

    const { mutate: createNetSuiteExpenseLineMatching, isLoading: isLoadingCreateNetSuiteExpenseLineMatching } =
        useCreateNetSuiteExpenseLineMatching();

    if (lineType === domain.NetSuiteMatchingLineType.Item) {
        return {
            createMatching: createNetSuiteItemLineMatching,
            isLoadingCreateMatching: isLoadingCreateNetSuiteItemLineMatching,
        };
    }

    return {
        createMatching: createNetSuiteExpenseLineMatching,
        isLoadingCreateMatching: isLoadingCreateNetSuiteExpenseLineMatching,
    };
};
